import type { FeedbackSurveyConfig } from "@mcblessing1/in-app-feedback";
import { getProductFeedbackSurveyId } from "./productFeedbackEnv";
import { PRODUCT_FEEDBACK_QUESTION_IDS } from "./surveyQuestionIds";

/** Host FeedbackSurveyConfig: env survey id + code question ids. */
export function getProductFeedbackSurveyConfig(): FeedbackSurveyConfig {
  return {
    surveyId: getProductFeedbackSurveyId(),
    questionIds: {
      category: PRODUCT_FEEDBACK_QUESTION_IDS.category,
      primary: PRODUCT_FEEDBACK_QUESTION_IDS.primary,
      secondary: PRODUCT_FEEDBACK_QUESTION_IDS.secondary,
      anythingElse: PRODUCT_FEEDBACK_QUESTION_IDS.anythingElse,
    },
  };
}
